import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { PixTransferReturnSucesso } from '../models/transfer-return.model';
import { PixReceipt } from '../models/receipt.model';
import { Util } from '../../../utils/util';
import { BaseResult } from '../../../shared/models/base.result.model';
@Injectable()
export class PixReceiptService {
	private url = endpoints.bankStatement;


	constructor(private http: HttpClient) { }

	getReceipt(codigoTransacao: number): Observable<BaseResult<PixTransferReturnSucesso>> {
		return this.http.get<BaseResult<PixTransferReturnSucesso>>(`${this.url.detail}?codigoTransacao=${codigoTransacao}`);
	}

	convertModelToReceipt(ret: PixTransferReturnSucesso) {
		const model = new PixReceipt();
		model.numeroConta = ret.transacaoPix.numeroConta;
		model.tipoConta  = ret.transacaoPix.tipoConta;
		model.agencia = ret.transacaoPix.agencia;
		model.complemento = ret.transacaoPix.complemento;
		model.documento = ret.transacaoPix.documento;
		model.codigoFimAFim = ret.transacaoPix.codigoFimAFim;
		model.codigoFimAFimDevolucao = ret.transacaoPix.codigoFimAFimDevolucao;
		model.iSPBCodigo = ret.transacaoPix.codigoISPB;
		model.iSPBNome = ret.transacaoPix.nomeISPB;
		model.nome = ret.transacaoPix.nome;
		model.codigoTransacao = ret.codigoTransacao;
		model.dataTransacao = ret.dataTransacao;
		model.dataContabil = ret.dataContabil;
		model.tipoMovimentacao = ret.tipoMovimentacao;
		model.tipoTransacao = ret.tipoTransacao;
		model.valor = ret.valor;
		model.tipoOperacao = ret.transacaoPix.tipoOperacao;
		model.valores = ret.transacaoPix.valores
		model.autenticacao 	= ret.transacaoPix.autenticacao;

		if (ret.transacaoPix.transacaoOriginal) {
			model.descricaoOriginal = ret.transacaoPix.transacaoOriginal.descricao;
			model.valorOriginal = ret.transacaoPix.transacaoOriginal.valor;
			model.dataTransacaoOriginal = ret.transacaoPix.transacaoOriginal.dataTransacao;
		}

		return model;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/receipt/receipt.service.ts